<template>
  <div class="md:container md:mx-auto">
    <Head title="New Project" />
    <h1 class="mb-8 text-4xl font-bold">
      New Project
    </h1>
    <form @submit.prevent="store">
       <!-- Main Column Container  -->
       <div class="md:flex md:space-x-4">
          <!-- Project -->
          <div class="w-full md:w-1/3 p-1">
            <h2 class="pb-4 italic text-xl">Project</h2>

            <div class="flex flex-wrap mb-2 w-full">
              <text-input v-model="form.title" name="title" :error="form.errors.title" class="pb-4 pr-4 w-full" label="Project Title *" placeholder="Project Title" tabindex="1" required />
            </div>
            <div class="flex flex-wrap mb-2">
              <text-input v-model="form.address" name="address" :error="form.errors.address" class="pb-4 pr-4 w-full" label="Project Address" placeholder="Address" tabindex="2" />
            </div>
            <div class="flex flex-wrap mb-2">
              <text-input v-model="form.city" name="city" :error="form.errors.city" class="pb-4 pr-4 w-full" label="City" placeholder="City" tabindex="3" />
            </div>
            <div class="flex flex-wrap mb-2">
              <text-input v-model="form.state" name="state" :error="form.errors.state" class="pb-4 pr-4 w-full" label="State/Region" placeholder="State/Region" tabindex="4" />
            </div>
            <div class="flex flex-wrap mb-2">
              <text-input v-model="form.country" name="country" :error="form.errors.country" class="pb-4 pr-4 w-full" label="Country" placeholder="Select Country" tabindex="5" />
            </div>
            <div class="flex flex-wrap mb-2">
              <text-input v-model="form.zipcode" name="zipcode" :error="form.errors.zipcode" class="pb-4 pr-4 w-full" label="Zip/Post Code" placeholder="Zip/Post Code" tabindex="6" />
            </div>
            <div v-if="auth.user.is_admin" class="flex flex-wrap mb-2">
              <select-input v-model="form.price_list_id" :error="form.errors.price_list_id" class="pb-4 pr-4 w-full" label="Price List" tabindex="7">
                <option v-for="pl in pricelists" :key="pl.id" :value="pl.id"> {{ pl.name }}</option>
              </select-input>
            </div>

          </div>

          <!-- Customer -->
          <div class="w-full md:w-1/3 p-1">
            <h2 class="pb-4 italic text-xl">Customer</h2>
            <div class="flex flex-wrap mb-2">
              <text-input v-model="form.company" name="company" :error="form.errors.company" class="pb-4 pr-4 w-full" label="Company *" placeholder="Company name" tabindex="8" required />
            </div>
            <div class="flex flex-wrap mb-2">
              <text-input v-model="form.contact" name="contact" :error="form.errors.contact" class="pb-4 pr-4 w-full" label="Contact *" placeholder="Contact name" tabindex="9" required />
            </div>
            <div class="flex flex-wrap mb-2">
              <text-input v-model="form.email" name="email" :error="form.errors.email" class="pb-4 pr-4 w-full" type="email" label="Email *" placeholder="Email Address" tabindex="10" required />
            </div>
            <div class="flex flex-wrap mb-2">
              <text-input v-model="form.phone" name="phone" :error="form.errors.phone" class="pb-4 pr-4 w-full" type="tel" mask="(###) ###-####" label="Phone" placeholder="Phone number" tabindex="11" />
            </div>
            <div class="flex flex-wrap mb-2">
              <text-input v-model="form.branch_location" name="branch_location" :error="form.errors.branch_location" class="pb-4 pr-4 w-full" label="Branch Location *" placeholder="Branch Location" tabindex="12" required />
            </div>
            <div class="flex flex-wrap mb-2">
              <text-input v-model="form.company_city" name="company_city" :error="form.errors.company_city" class="pb-4 pr-4 w-full" label="City" placeholder="Company City" tabindex="13" />
            </div>
            <div class="flex flex-wrap mb-2">
              <text-input v-model="form.company_state" name="company_state" :error="form.errors.company_state" class="pb-4 pr-4 w-full" label="State" placeholder="Company State" tabindex="14" />
            </div>
          </div>

          <!-- Manufacturer Rep -->
          <div class="w-full md:w-1/3 p-1">
            <h2 class="pb-4 italic text-xl">Manufacturer Rep</h2>

            <div class="flex flex-wrap mb-2">
              <label for="dealer" class="font-bold mb-2 w-full">Select/Update Rep Contact</label>
              <!-- <v-multiselect
                id="dealer"
                v-model="form.dealer"
                placeholder="Rep Contact"
                noOptions="Not found"
                track-by="id"
                label="Dealer Contact"
                class="pb-4 pr-4 w-full"
                :options="dealers"
                :loading="isLoading"
                :internal-search="false"
                :custom-label="nameWithMail"
                noOptionsText="Not found"
                @select="onUserSelect"
                @search-change="onSearchChange"
              /> -->
              <v-multiselect
                id="dealer"
                v-model="form.dealer"
                placeholder="Rep Contact"
                track-by="id"
                label="Dealer Contact"
                class="pb-4 pr-4 w-full"
                :options="dealers"
                :loading="isLoading"
                :internal-search="false"
                :custom-label="nameWithMail"
                @select="onUserSelect"
                @search-change="onSearchChange"
              >
                <template #noOptions>
                  <span>Search a Name</span>
                </template>
              </v-multiselect>
            </div>
            <div class="flex flex-wrap justify-end mb-2">
              <div class="">
                <button
                  type="button"
                  class="border border-blue-400 py-2 px-8 mb-4 mr-3.5"
                  @click="toggleEditRep"
                >
                  Add New Sales Rep
                </button>
              </div>
            </div>

            <h2 class="italic text-xl mt-24 mb-2">Rep Contact Information</h2>
            <text-input
                v-model="form.rep_id"
                name="rep_id"
                class="hidden"
            />
            <div class="flex flex-wrap mb-2">
              <select-input
                :key="selectKey"
                ref="repAgencySelect"
                v-model="form.rep_agency"
                :error="form.errors.rep_agency"
                :class="{ 'opacity-70': !isEditingRep }"
                class="pb-4 pr-4 w-full"
                label="Rep Agency"
                tabindex="16"
                :disabled="!isEditingRep"
              >
                <option v-for="agency in agencies" :key="agency.id" :value="agency.id">{{ agency.name }}</option>
              </select-input>
            </div>
            <div class="flex flex-wrap mb-2">
              <text-input
                v-model="form.rep_first_name"
                name="rep_first_name"
                :error="form.errors.rep_first_name"
                :class="{ 'opacity-70': !isEditingRep }"
                class="pb-4 pr-2 w-1/2"
                label="First Name"
                placeholder="First Name"
                tabindex="17"
                :readonly="!isEditingRep"
              />
              <text-input
                v-model="form.rep_last_name"
                name="rep_last_name"
                :error="form.errors.rep_last_name"
                :class="{ 'opacity-70': !isEditingRep }"
                class="pb-4 pl-2 pr-3.5 w-1/2"
                label="Last Name"
                placeholder="Last Name"
                tabindex="18"
                :readonly="!isEditingRep"
              />
            </div>
            <div class="flex flex-wrap mb-2">
              <text-input
                v-model="form.rep_email"
                name="rep_email"
                :error="form.errors.rep_email"
                :class="{ 'opacity-70': !isEditingRep }"
                class="pb-4 pr-4 w-full"
                type="email"
                label="Email"
                placeholder="Rep Email"
                tabindex="19"
                :readonly="!isEditingRep"
              />
            </div>
            <div class="flex flex-wrap mb-2">
              <text-input
                v-model="form.rep_phone"
                name="rep_phone"
                :error="form.errors.rep_phone"
                :class="{ 'opacity-70': !isEditingRep }"
                class="pb-4 pr-4 w-full"
                type="tel"
                label="Phone"
                mask="(###) ###-####"
                placeholder="Rep Phone Number"
                tabindex="20"
                :readonly="!isEditingRep"
              />
            </div>
          </div>
      </div>
      <div class="w-full pr-6 lg:w-1/2">
        <loading-button :loading="form.processing" class="btn-blue" type="submit">Create Project</loading-button>
      </div>
    </form>
    <!-- Submit Button -->

  </div>
</template>



<script>
import { Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import VMultiselect from 'vue-multiselect'
import { debounce } from 'lodash'

export default {
  components: {
    Head,
    TextInput,
    SelectInput,
    LoadingButton,
    VMultiselect,
  },
  layout: Layout,
  remember: 'form',
  props: {
    auth: Object,
    pricelists: Array,
    pricelist: Number,
    agencies: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        title        : null,
        address      : null,
        city         : null,
        state        : null,
        country      : null,
        zipcode      : null,
        price_list_id: this.pricelist,
        company        : null,
        contact        : null,
        email          : null,
        phone          : null,
        branch_location: null,
        company_city   : null,
        company_state  : null,
        users  : [],
        dealer: null,
        dealer_name: null,
        rep_contact: null,
        rep_agency: null,
        rep_first_name: null,
        rep_last_name: null,
        rep_email: null,
        rep_phone: null,
        rep_id: null, // Variable to store the selected rep's ID
      }),
      dealers: [],
      isLoading: false,
      selectKey: 0,
      isEditingRep: false, // Controls whether fields are editable

    }
  },
  computed: {
    hasRepErrors() {
      // Only return true if any of the specific rep fields have errors
      return (
        this.form.errors.rep_agency ||
        this.form.errors.rep_first_name ||
        this.form.errors.rep_last_name ||
        this.form.errors.rep_email ||
        this.form.errors.rep_phone
      );
    },
  },
  watch: {
    // Watch for changes in specific rep errors to enable editing only if they have errors
    hasRepErrors(newVal) {
      if (newVal) {
        this.isEditingRep = true; // Enable editing mode if specific rep fields have errors
      }
    },
  },
  methods: {
    store() {
      this.form.post('/projects')
    },
    onSearchChange: debounce(function(query) {
      this.getData(query);
    }, 500),
    getCsrfToken() {
      const match = document.cookie.match(new RegExp('(^| )XSRF-TOKEN=([^;]+)'));
      return match ? decodeURIComponent(match[2]) : null;
    },
    getData(query) {
      this.isLoading = true;

      if (query.length > 0) {
        fetch(`/search-users?userSearch=${query}`, {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'X-CSRF-TOKEN': this.getCsrfToken(), // Usar el token CSRF
          },
          credentials: 'same-origin' // Enviar cookies de sesión para autenticación
        })
        .then(response => response.json())
        .then(data => {
          this.dealers = data.users || [];
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
        });
      } else {
        this.dealers = [];
        this.isLoading = false;
      }
    },
    nameWithMail ({ name, email }) {
      return `${name}`;
    },
    onUserSelect(selectedOption) {
      if (selectedOption) {
        this.form.rep_first_name = selectedOption.first_name;
        this.form.rep_last_name = selectedOption.last_name;
        this.form.rep_email = selectedOption.email;
        this.form.rep_phone = selectedOption.phone;

        // Set rep_agency and increment selectKey to force re-render
        this.form.rep_agency = selectedOption.company_id;
        this.selectKey += 1; // Update the key to trigger reactivity
        this.form.dealer = null;
        this.form.rep_id = selectedOption.id;
      }
    },
    toggleEditRep() {
      this.form.rep_first_name = null;
      this.form.rep_last_name = null;
      this.form.rep_email = null;
      this.form.rep_phone = null;

      // Set rep_agency and increment selectKey to force re-render
      this.form.rep_agency = null;
      this.selectKey += 1; // Update the key to trigger reactivity

      this.form.dealer = null;
      this.isEditingRep = true; // Enable editing mode
      this.form.rep_id = 'new';
    },
  },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style>
@media (max-width: 1024px) {
    .multiselect {
        max-width: 22.5rem !important;
    }
}
.multiselect__select {
  right: 20px !important; /* Ajusta según sea necesario */
}

.multiselect__option--highlight,
.multiselect__option--highlight::after {
  background-color: #0052A4 !important;
  /* color: #000; Ajusta el color del texto si es necesario */
}
.multiselect__spinner {
  border-color: #0052A4 transparent transparent transparent; /* Cambia el primer valor para el color deseado */
}
</style>
